module.exports = __webpack_public_path__ + "media/images/registration/registration-e755dac8835821eb14847aeac5578f92.jpg";